import React from 'react'
import { APArticleMainImage, APRelatedArticleTitle, ArticleContentBlur } from './ArticlePageStyles'
import { getImageLink } from 'src/mentor/helpers/utilityFunctions'
import { useNavigate } from 'react-router-dom'
import LockIcon from '@mui/icons-material/Lock'

export const APRelatedArticle = ({ articleData }) => {
  const navigate = useNavigate()
  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => {
        if (articleData?.slug) {
          navigate(`/article/${articleData?.slug}`)
        } else if (articleData?.id) {
          navigate(`/article/id/${articleData?.id}`)
        }
      }}
    >
      <APArticleMainImage
        style={{ margin: '20px 0 10px 0' }}
        src={getImageLink(articleData?.blogBanner, articleData?.coverImage)}
      />
      <APRelatedArticleTitle>{articleData?.title}</APRelatedArticleTitle>
    </div>
  )
}

export const APArticleBlur = ({ openPrewall, openAuthModal }) => {
  return (
    <ArticleContentBlur>
      <div
        style={{
          position: 'absolute',
          margin: '10px auto 80px',
          bottom: 0,
          left: 0,
          right: 0,
          textAlign: 'center',
          fontWeight: 500,
          fontSize: '16px',
        }}
      >
        <LockIcon style={{ fontSize: '30px' }} />

        {localStorage.getItem('token') ? (
          <>
            <div>Upgrade to AUMHUM Premium</div>
            <div>and access this and everything else</div>
            <div style={{ cursor: 'pointer' }} onClick={openPrewall}>
              <u>Upgrade</u>
            </div>
          </>
        ) : (
          <>
            <div>This is a member-only article</div>
            <div>
              Please{' '}
              <span style={{ cursor: 'pointer' }} onClick={() => openAuthModal('login')}>
                Login
              </span>
              <span style={{ cursor: 'pointer' }} onClick={() => openAuthModal('signup')}>
                {' '}
                /Sign up
              </span>{' '}
              to read.
            </div>
          </>
        )}
      </div>
    </ArticleContentBlur>
  )
}
